// extracted by css-extract-rspack-plugin
export default {"AggregateLabels":"single-select-group-header-label-module__AggregateLabels__SJgVU","SanitizedHtml":"single-select-group-header-label-module__SanitizedHtml__tpqmv"};